const FormSelect = ({ 
    label, 
    name, 
    value,
    options = [],
    onChange, 
    placeholder, 
    color, 
    textColor, 
    placeholderColor,
    error,
    disabled
  }) => (
    <div style={formFieldStyle}>
      <label style={labelStyle(textColor)}>{label}</label>
      <div style={inputContainerStyle(color)}>
        <select
          name={name}
          value={value}
          onChange={onChange}
          style={inputStyle(placeholderColor)}
          disabled={disabled}
        >
          <option value="" disabled style={{ color: placeholderColor }}>
            {placeholder}
          </option>
          {options.map(option => (
            <option 
              key={option.value || option} 
              value={option.value || option}
              style={{ color: textColor }}
            >
              {option.label || option}
            </option>
          ))}
        </select>
      </div>
      {error && (
        <span
          style={{
            color: "red",
            fontSize: "12px",
            fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
          }}
        >
          {error}
        </span>
      )}
    </div>
  );

  export default FormSelect;

  const formFieldStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    flex: "1 1 0",
  };

  const labelStyle = (color) => ({
    color,
    fontSize: "12px",
    fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
    fontWeight: "400",
  });

  const inputContainerStyle = (color) => ({
    padding: "12px 16px",
    background: "white",
    borderRadius: "8px",
    outline: `1px solid ${color}`,
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: "1 1 0",
  });

  const inputStyle = (placeholderColor) => ({
    flex: "1 1 0",
    border: "none",
    outline: "none",
    background: "transparent",
    color: "inherit",
    fontSize: "16px",
    fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
    fontWeight: "400",
    lineHeight: "24px",
    "::placeholder": {
      color: placeholderColor,
    },
  });

  const dropdownIconStyle = {
    width: "24px",
    height: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };